var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['countdown', { 'countdown-red': _vm.remainingTime <= 60 }]},[_vm._v(" "+_vm._s(_vm.formattedTime)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }